export enum TagType {
  Info = "Info",
  Agent = "Agent",
  Group = "Group",
  Branch = "Branch",
  Account = "Account",
  Area = 'Area',
  Resource = 'Resource'
}
